import { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle, WarningCircle } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * TECHS発注チェック（2026-10-21）— 部品受注入力 と 部品手配入力 が要る項目が
 * 埋まっているかを、登録のそばで出す。TECHS への自動連携は無い。
 */
export const TechsReadinessPanel = ({
  value, register, deptCode = '', context = '', departmentName = '',
  testId = 'techs-readiness', onDefaults,
}) => {
  const [res, setRes] = useState(null);

  const partNo = value?.sku || value?.asset_no || value?.number_value?.next
    || value?.number_value?.preview || '';
  const key = [partNo, value?.name, value?.uom, value?.order_category_id,
    value?.needed_by, register, deptCode].join('|');

  useEffect(() => {
    let dead = false;
    axios.post(`${API}/techs/order-check`, {
      part_no: partNo || null,
      name: value?.name || null,
      model_no: value?.model_no || null,
      uom: value?.uom || null,
      // 登録の時点では員数＝1（発注のときに 部品受注入力 で決める）
      qty: Number(value?.qty_total || value?.qty || 1) || 1,
      needed_by: value?.needed_by || null,
      order_category_id: value?.order_category_id || null,
      order_category_name: value?.order_category_name || null,
      register, dept_code: deptCode || null, context: context || null,
      department_name: departmentName || null,
    }).then((r) => {
      if (dead) return;
      setRes(r.data);
      onDefaults?.(r.data);
    }).catch(() => { if (!dead) setRes(null); });
    return () => { dead = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  if (!res) return null;
  const ok = res.ok && res.techs_master_registered;
  return (
    <div className={`rounded-lg border p-3 ${ok ? 'border-emerald-200 bg-emerald-50/60' : 'border-rose-200 bg-rose-50/60'}`}
      data-testid={testId}>
      <p className="flex items-center gap-1.5 text-[12px] font-semibold text-zinc-800">
        {ok ? <CheckCircle size={14} weight="fill" className="text-emerald-600" />
          : <WarningCircle size={14} weight="fill" className="text-rose-600" />}
        TECHS発注チェック
        <span className={ok ? 'text-emerald-800' : 'text-rose-800'} data-testid={`${testId}-state`}>
          {ok ? 'そのまま部品受注入力へ進めます' : '足りない項目があります'}
        </span>
      </p>
      {res.missing?.length > 0 && (
        <ul className="mt-1.5 flex flex-wrap gap-1.5" data-testid={`${testId}-missing`}>
          {res.missing.map((m) => (
            <li key={m} className="rounded-full border border-rose-200 bg-white px-2 text-[11px] font-semibold text-rose-700">
              {m}
            </li>
          ))}
        </ul>
      )}
      {res.warnings?.map((w) => (
        <p key={w} className="mt-1.5 text-[11px] font-medium text-amber-800" data-testid={`${testId}-warning`}>
          {w}
        </p>
      ))}
      <p className="mt-1.5 text-[10px] text-zinc-600" data-testid={`${testId}-defaults`}>
        受注分類: {res.order_category_default
          ? `${res.order_category_default.techs_code} ${res.order_category_default.name}`
          : '（既定なし — 選んでください）'}
        {' ／ '}納入先: {res.deliver_to_default
          ? `${res.deliver_to_default.code} ${res.deliver_to_default.name}` : '（部署から決まりません）'}
        {' ／ '}製品: {res.product_label}
      </p>
    </div>
  );
};

export default TechsReadinessPanel;
